import { Card } from '../../Dashboards/Common/Charts/Card';
import { currency } from '../../Dashboards/Common/Util/currency';
import { useChartsDataContext } from './hooks/useChartsDataContext';

export const Indicators = () => {
    const { state } = useChartsDataContext();

    return (
        <div className="w-100 d-flex">
            <Card
                title="Total Débito"
                value={currency.formatToBrCurrency(
                    -state.data.indicators[0]?.debit_value || 0
                )}
            />
            <Card
                title="Total Crédito"
                value={currency.formatToBrCurrency(
                    state.data.indicators[0]?.credit_value || 0
                )}
            />
        </div>
    );
};
